var React = require('react');

function EmailInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 0H2C1.175 0 0.5075 0.675 0.5075 1.5L0.5 10.5C0.5 11.325 1.175 12 2 12H14C14.825 12 15.5 11.325 15.5 10.5V1.5C15.5 0.675 14.825 0 14 0ZM14 10.5H2V3L8 6.75L14 3V10.5ZM8 5.25L2 1.5H14L8 5.25Z","fill":"#363636"}));
}

EmailInline.defaultProps = {"width":"16","height":"12","viewBox":"0 0 16 12","fill":"none"};

module.exports = EmailInline;

EmailInline.default = EmailInline;
